import { Form, Tooltip } from "antd";
import { MdEdit } from "react-icons/md";
import useModal from "../../hooks/useModalPlanejamentoOperacoes";
import { useFilters } from "features/filters/store";
import {
  CustomModal,
  Header,
  RoundedTable,
  ButtonAddItem,
  ContainerTable,
  ModalContainer,
  ModalTableContentWrap,
  ContentFooter
} from "./styles";
import columnsOperations from "./partials/Operations";
import columnsHistories from "./partials/Histories";
import {
  useGetListaPorTalhao,
  useGetHistoricoOrdemServico,
} from "../../hooks/useGetHistoricoPlanejamentoOperacao";
import useAlvoDropdownList from "../../hooks/useAlvoDropdownList"
import { TabbarModal } from "./TabbarModal";
import ModalAnteciparOuProrrogar from "./ModalAnteciparOuProrrogar";
import ModalCancelarOperacao from "./ModalCancelarOperacao";
import { getDataOrdenacao } from "./utils";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";
import { Loader } from "../ImportModal/Loader";
import ModalHistoricoOperacao from "./ModalHistoricoOperacao";
import { Planejamento } from "../../interfaces/Planejamento";
import ModalNovaOperacao from "./ModalNovaOperacao";
import ModalEncerrarOuReabrir from "./ModalEncerrarOuReabrir";

const { useForm } = Form;

interface CreateEditModalProps {
  refetch?: () => void;
  filtersData?: any
  dados?: any
  dataComponente?: any
  planoOperacionalData: Planejamento
}

function ModalPlanejamentoOperacoes({ filtersData, dados, dataComponente, planoOperacionalData }: CreateEditModalProps) {
  const { filters: { filtersAdvanced } } = useFilters();

  const [form] = useForm();
  const { hasPermission } = useValidatePermission();

  const {
    talhaoId,
    isOpen,
    code,
    setIsOpen,
    setCode,
    setId,
    setIds,
    menuOption,
    setIsCancelOperationModal,
    setIsAnteciparOuProrrogarModal,
    setAnteciparOuProrrogar,
    setIsModalHistoricoOperacao,
    setIsModalCadastroOperacao,
    isAnteciparOuProrrogarModal,
    isCancelOperationModal,
    isModalHistoricoOperacao,
    isModalCadastroOperacao,
    setPlanoOperacionalOperacaoTalhao,
    planejamentoOperacionalPorTalhao,
    setIsEncerrarOuReabrirModal,
    setCodigoEncerrarOuReabrirModal
  } = useModal();

  const { data: dropdownDataList } = useAlvoDropdownList({ OcupacaoId: form.getFieldValue('cultura') });

  const { data: listOperacional, refetch: refetchListaPorTalhao, isFetching } = useGetListaPorTalhao(talhaoId, { safraPeriodoId: filtersAdvanced.safraPeriodo }, isOpen);
  const { data: listHistorico } = useGetHistoricoOrdemServico(talhaoId, isOpen);

  filtersData = {
    ...filtersData,
    componentesList: dataComponente,
    alvosList: dropdownDataList
  };

  function handleClose() {
    setIsOpen(false);
    setCode(-1);
    setId('');
    setIds([]);
  }

  const listColumnComponent = menuOption === "operacoes" ?
    columnsOperations(
      setIsCancelOperationModal,
      setIsAnteciparOuProrrogarModal,
      setAnteciparOuProrrogar,
      setIsModalHistoricoOperacao,
      setPlanoOperacionalOperacaoTalhao,
      listOperacional || [],
      hasPermission,
      setIsEncerrarOuReabrirModal,
      setCodigoEncerrarOuReabrirModal
    ) : columnsHistories();

  const listColumnData = menuOption === "operacoes" ?
    listOperacional : listHistorico?.sort((a, b) => getDataOrdenacao(a) - getDataOrdenacao(b));

  return (
    <CustomModal
      title={
        <Header>
          <MdEdit size={28} />
            Editar Planejamento do talhão {code} - Ýrea: {Number(planejamentoOperacionalPorTalhao?.tamanhoAreaHa)?.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}ha
        </Header>
      }
      visible={isOpen}
      width={"95%"}
      onCancel={handleClose}
      zIndex={1000}
      maskClosable={false}
      destroyOnClose
      centered
      getContainer={document.body}
      style={{ top: 20 }}
      modalRender={(dom) => (
        <div style={{ position: "relative" }}>
          {(isAnteciparOuProrrogarModal || isCancelOperationModal || isModalHistoricoOperacao || isModalCadastroOperacao) && <div className="inner-overlay" />}
          {isFetching && <Loader />}
          {dom}
        </div>
      )}
      footer={menuOption === "operacoes" &&
        <ContentFooter>
          <Tooltip title={!hasPermission(['MapaCronograma.IncluirOperacaoAvulsa']) ? " Vocé não tem permissão para incluir nova operação avulsa" : undefined}>
            <span style={{ display: "inline-block" }}>
              <ButtonAddItem onClick={() => {
                if (hasPermission(['MapaCronograma.IncluirOperacaoAvulsa']))
                  setIsModalCadastroOperacao(true);

              }} disabled={!hasPermission(['MapaCronograma.IncluirOperacaoAvulsa']) || isFetching}>Adicionar Nova Operação</ButtonAddItem></span>
          </Tooltip>
        </ContentFooter>
      }
    >
      <TabbarModal />
      <ModalContainer>
        <ModalTableContentWrap>
          <ContainerTable>
            <RoundedTable
              style={{ marginBottom: 16 }}
              columns={listColumnComponent}
              dataSource={isFetching ? [] : listColumnData}
              scroll={{ y: '60vh' }}
              pagination={false}
            />
          </ContainerTable>
        </ModalTableContentWrap>
        <ModalAnteciparOuProrrogar refetch={refetchListaPorTalhao} />
        <ModalCancelarOperacao refetch={refetchListaPorTalhao} />
        <ModalNovaOperacao planoOperacionalData={planoOperacionalData} filtersData={{ ...dados, dataComponente }} />
        <ModalHistoricoOperacao />
        <ModalEncerrarOuReabrir refetch={refetchListaPorTalhao} />
      </ModalContainer>
    </CustomModal>
  );
}

export default ModalPlanejamentoOperacoes;
